/** File automatically generated by 'update-version.js', do not edit. */
export const versionEnv = {
  version: '1.0.3',
  commitHash: '5e25d0c13fa9952dc289ef5b81239140a18ca38d',
  buildDate: '2024-11-19T14:16:35.661Z'
};